<div
  appThrottleClick
  (throttleClick)="navItemSelected()"
  [ngClass]="{ active: isNavItemActive$ | async }"
  class="nav-item active custom-nav-item">
  <div class="nav-item-label" [ngClass]="{ 'multi-line-label': multiLineNavItem$ | async }">
    {{ navItem.name }}
  </div>
</div>
